/**
 * Boolean Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.booleanFormatter = function(value, row) {
    if (value === 1 || value === "1" || value === true || value === "TRUE") {
        return '<i class="fa fa-check text-success"></i>';
    }
    return '<i class="fa fa-xmark text-muted"></i>';
};
